// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: HjOQzkYiDOKN
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import BankTransferButton from "../../BankTransferButton"; // plasmic-import: rey7Nya4BVsS/component
import CardPaymentButton from "../../CardPaymentButton"; // plasmic-import: OfVv5HyvOBk9/component
import InvoiceItem from "../../InvoiceItem"; // plasmic-import: -fR3b8VmLe9a/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicCurrentInvoicePaymentsPagePreview.module.css"; // plasmic-import: HjOQzkYiDOKN/css
import Icon4Icon from "./icons/PlasmicIcon__Icon4"; // plasmic-import: sgRe6pjmwXSr/icon
import Line2Icon from "./icons/PlasmicIcon__Line2"; // plasmic-import: pAewef34g4ck/icon
import Line1Icon from "./icons/PlasmicIcon__Line1"; // plasmic-import: MRg3okKdNvAo/icon

createPlasmicElementProxy;

export const PlasmicCurrentInvoicePaymentsPagePreview__VariantProps =
  new Array();

export const PlasmicCurrentInvoicePaymentsPagePreview__ArgProps = new Array(
  "sendText",
  "invoiceNumber",
  "sidebarAmount",
  "merchantName",
  "amount",
  "dueDate"
);

const $$ = {};

function PlasmicCurrentInvoicePaymentsPagePreview__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <div className={classNames(projectcss.all, sty.freeBox__aebv)}>
            <Icon4Icon
              data-plasmic-name={"goBackArrow"}
              data-plasmic-override={overrides.goBackArrow}
              className={classNames(projectcss.all, sty.goBackArrow)}
              role={"img"}
            />

            <div
              data-plasmic-name={"goBackText"}
              data-plasmic-override={overrides.goBackText}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.goBackText
              )}
            >
              {"Go Back"}
            </div>
            <div
              data-plasmic-name={"sendButton"}
              data-plasmic-override={overrides.sendButton}
              className={classNames(projectcss.all, sty.sendButton)}
            >
              <div
                data-plasmic-name={"sendText"}
                data-plasmic-override={overrides.sendText}
                className={classNames(projectcss.all, sty.sendText)}
              >
                {renderPlasmicSlot({
                  defaultContents: "Create Invoice",
                  value: args.sendText,
                  className: classNames(sty.slotTargetSendText)
                })}
              </div>
            </div>
          </div>
          <div
            data-plasmic-name={"previewBody"}
            data-plasmic-override={overrides.previewBody}
            className={classNames(projectcss.all, sty.previewBody)}
          >
            <div className={classNames(projectcss.all, sty.freeBox__keGum)}>
              <div
                data-plasmic-name={"companyName"}
                data-plasmic-override={overrides.companyName}
                className={classNames(projectcss.all, sty.companyName)}
              >
                {renderPlasmicSlot({
                  defaultContents: "Pulsebound",
                  value: args.merchantName,
                  className: classNames(sty.slotTargetMerchantName)
                })}
              </div>
              <div
                data-plasmic-name={"rectangle29"}
                data-plasmic-override={overrides.rectangle29}
                className={classNames(projectcss.all, sty.rectangle29)}
              >
                <div
                  data-plasmic-name={"figmaPaste"}
                  data-plasmic-override={overrides.figmaPaste}
                  className={classNames(projectcss.all, sty.figmaPaste)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__ldIuG)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        sty.freeBox___4V5T4
                      )}
                    >
                      {renderPlasmicSlot({
                        defaultContents: "$1,000.00 ",
                        value: args.amount,
                        className: classNames(sty.slotTargetAmount)
                      })}
                    </div>
                    <div
                      className={classNames(
                        projectcss.all,
                        sty.freeBox___8I34A
                      )}
                    >
                      {renderPlasmicSlot({
                        defaultContents: "due on September 21, 2022",
                        value: args.dueDate,
                        className: classNames(sty.slotTargetDueDate)
                      })}
                    </div>
                  </div>
                  <Line2Icon
                    className={classNames(projectcss.all, sty.svg__jSwYe)}
                    role={"img"}
                  />

                  <div
                    data-plasmic-name={"viewDetails"}
                    data-plasmic-override={overrides.viewDetails}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.viewDetails
                    )}
                  >
                    {"View Invoice Details  >"}
                  </div>
                </div>
              </div>
              <div
                data-plasmic-name={"rectangle28"}
                data-plasmic-override={overrides.rectangle28}
                className={classNames(projectcss.all, sty.rectangle28)}
              >
                <div
                  data-plasmic-name={"figmaPaste2"}
                  data-plasmic-override={overrides.figmaPaste2}
                  className={classNames(projectcss.all, sty.figmaPaste2)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__svpAx
                    )}
                  >
                    {"Choose your payment method"}
                  </div>
                  <Line1Icon
                    className={classNames(projectcss.all, sty.svg__m9NyW)}
                    role={"img"}
                  />

                  <BankTransferButton
                    data-plasmic-name={"handleBankTransfer"}
                    data-plasmic-override={overrides.handleBankTransfer}
                    className={classNames(
                      "__wab_instance",
                      sty.handleBankTransfer
                    )}
                  />

                  <CardPaymentButton
                    data-plasmic-name={"handleCardPayment"}
                    data-plasmic-override={overrides.handleCardPayment}
                    className={classNames(
                      "__wab_instance",
                      sty.handleCardPayment
                    )}
                  />
                </div>
              </div>
              <div
                data-plasmic-name={"figmaPaste3"}
                data-plasmic-override={overrides.figmaPaste3}
                className={classNames(projectcss.all, sty.figmaPaste3)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__lsjZ2
                  )}
                >
                  {"Powered by astrius"}
                </div>
              </div>
            </div>
            <div
              data-plasmic-name={"sideBarInstance"}
              data-plasmic-override={overrides.sideBarInstance}
              className={classNames(projectcss.all, sty.sideBarInstance)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__yIbd0)}>
                <div
                  data-plasmic-name={"closeButton"}
                  data-plasmic-override={overrides.closeButton}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.closeButton
                  )}
                >
                  {"X"}
                </div>
                <div
                  data-plasmic-name={"closeButton2"}
                  data-plasmic-override={overrides.closeButton2}
                  className={classNames(projectcss.all, sty.closeButton2)}
                >
                  {renderPlasmicSlot({
                    defaultContents: "Invoice #12",
                    value: args.invoiceNumber,
                    className: classNames(sty.slotTargetInvoiceNumber)
                  })}
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__qNrCh)}>
                  {renderPlasmicSlot({
                    defaultContents: (
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__lbyl7
                        )}
                      >
                        {"$300.00"}
                      </div>
                    ),

                    value: args.sidebarAmount,
                    className: classNames(sty.slotTargetSidebarAmount)
                  })}
                </div>
              </div>
              <Stack__
                as={"div"}
                data-plasmic-name={"invoiceItemStack"}
                data-plasmic-override={overrides.invoiceItemStack}
                hasGap={true}
                className={classNames(projectcss.all, sty.invoiceItemStack)}
              >
                <InvoiceItem
                  data-plasmic-name={"invoiceItem"}
                  data-plasmic-override={overrides.invoiceItem}
                  className={classNames("__wab_instance", sty.invoiceItem)}
                  item={"Social Media Management"}
                />
              </Stack__>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "goBackArrow",
    "goBackText",
    "sendButton",
    "sendText",
    "previewBody",
    "companyName",
    "rectangle29",
    "figmaPaste",
    "viewDetails",
    "rectangle28",
    "figmaPaste2",
    "handleBankTransfer",
    "handleCardPayment",
    "figmaPaste3",
    "sideBarInstance",
    "closeButton",
    "closeButton2",
    "invoiceItemStack",
    "invoiceItem"
  ],

  goBackArrow: ["goBackArrow"],
  goBackText: ["goBackText"],
  sendButton: ["sendButton", "sendText"],
  sendText: ["sendText"],
  previewBody: [
    "previewBody",
    "companyName",
    "rectangle29",
    "figmaPaste",
    "viewDetails",
    "rectangle28",
    "figmaPaste2",
    "handleBankTransfer",
    "handleCardPayment",
    "figmaPaste3",
    "sideBarInstance",
    "closeButton",
    "closeButton2",
    "invoiceItemStack",
    "invoiceItem"
  ],

  companyName: ["companyName"],
  rectangle29: ["rectangle29", "figmaPaste", "viewDetails"],
  figmaPaste: ["figmaPaste", "viewDetails"],
  viewDetails: ["viewDetails"],
  rectangle28: [
    "rectangle28",
    "figmaPaste2",
    "handleBankTransfer",
    "handleCardPayment"
  ],

  figmaPaste2: ["figmaPaste2", "handleBankTransfer", "handleCardPayment"],
  handleBankTransfer: ["handleBankTransfer"],
  handleCardPayment: ["handleCardPayment"],
  figmaPaste3: ["figmaPaste3"],
  sideBarInstance: [
    "sideBarInstance",
    "closeButton",
    "closeButton2",
    "invoiceItemStack",
    "invoiceItem"
  ],

  closeButton: ["closeButton"],
  closeButton2: ["closeButton2"],
  invoiceItemStack: ["invoiceItemStack", "invoiceItem"],
  invoiceItem: ["invoiceItem"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames:
            PlasmicCurrentInvoicePaymentsPagePreview__ArgProps,
          internalVariantPropNames:
            PlasmicCurrentInvoicePaymentsPagePreview__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicCurrentInvoicePaymentsPagePreview__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicCurrentInvoicePaymentsPagePreview";
  } else {
    func.displayName = `PlasmicCurrentInvoicePaymentsPagePreview.${nodeName}`;
  }
  return func;
}

export const PlasmicCurrentInvoicePaymentsPagePreview = Object.assign(
  // Top-level PlasmicCurrentInvoicePaymentsPagePreview renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    goBackArrow: makeNodeComponent("goBackArrow"),
    goBackText: makeNodeComponent("goBackText"),
    sendButton: makeNodeComponent("sendButton"),
    sendText: makeNodeComponent("sendText"),
    previewBody: makeNodeComponent("previewBody"),
    companyName: makeNodeComponent("companyName"),
    rectangle29: makeNodeComponent("rectangle29"),
    figmaPaste: makeNodeComponent("figmaPaste"),
    viewDetails: makeNodeComponent("viewDetails"),
    rectangle28: makeNodeComponent("rectangle28"),
    figmaPaste2: makeNodeComponent("figmaPaste2"),
    handleBankTransfer: makeNodeComponent("handleBankTransfer"),
    handleCardPayment: makeNodeComponent("handleCardPayment"),
    figmaPaste3: makeNodeComponent("figmaPaste3"),
    sideBarInstance: makeNodeComponent("sideBarInstance"),
    closeButton: makeNodeComponent("closeButton"),
    closeButton2: makeNodeComponent("closeButton2"),
    invoiceItemStack: makeNodeComponent("invoiceItemStack"),
    invoiceItem: makeNodeComponent("invoiceItem"),
    // Metadata about props expected for PlasmicCurrentInvoicePaymentsPagePreview
    internalVariantProps:
      PlasmicCurrentInvoicePaymentsPagePreview__VariantProps,
    internalArgProps: PlasmicCurrentInvoicePaymentsPagePreview__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicCurrentInvoicePaymentsPagePreview;
/* prettier-ignore-end */
